<template>
    <div class="ibox administration-license">
        <div class="ibox-heading">
            <h3>{{ t_title }}</h3>
        </div>

        <div class="ibox-content">
            <div class="m-b-md" v-if="alterPrivilege">
                <v-btn type="button" class="btn btn-primary button-add-license m-r-sm" @click="showAddModal()">
                    <i class="fa-regular fa-plus fa-lg m-r-xs"></i>
                    {{ t_new_license }}
                </v-btn>
                <v-btn type="button" class="btn btn-primary button-add-license m-r-sm" @click="showAddNewProjectModal()">
                    <i class="fa-regular fa-plus fa-lg m-r-xs"></i>
                    {{ t_new_project_from_license }}
                </v-btn>
                <v-btn type="button" :class="[select_count ? '' : 'hidden','btn btn-secondary button-multidelete-license m-r-sm']" @click="showDeleteModal()">
                    <i class="fa-regular fa-xmark fa-lg m-r-xs"></i>
                    {{ t_delete_licenses }}
                </v-btn>
            </div>
            <div class="table-responsive">
                <table id="license-table"
                       class="table table-striped table-bordered table-hover"
                       cellspacing="0"
                       width="100%">
                    <thead>
                    <tr>
                        <th></th>
                        <th>{{ t_product_key }}</th>
                        <th>{{ t_customer_name }}</th>
                        <th>{{ t_project_name }}</th>
                        <th>{{ t_clients }}</th>
                        <th>{{ t_type }}</th>
                        <th>{{ t_validity }}</th>
                        <th>{{ t_updated_at }}</th>
                        <th>{{ t_created_at }}</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr v-for="(license, index) in inner_licenses"
                        :class="[license.selected ? 'selected' : '', index % 2 ? 'odd' : 'even', 'cs-row']" role="row">
                        <td class="select-checkbox text-center"><input type="checkbox" :id="'checkbox' + license.id" v-model="license.selected" value="0"></td>
                        <td>{{ license.productkey }}</td>
                        <td>{{ license.customer_name }}</td>
                        <td>{{ license.project_name }}</td>
                        <td>
                            <div class="label m-r-xs m-b-xs pull-left" v-if="license.client_count">{{ Object.keys(license.clients).length }} / {{ license.client_count }}</div>
                            <div class="label label-primary m-r-xs m-b-xs pull-left" v-for="client in license.clients">{{ client }}</div>
                        </td>
                        <td>{{ license.is_html5 ? 'HTML5' : 'Windows' }}</td>
                        <td>{{ license.validity.text }}</td>
                        <td>{{ license.updated_at }}</td>
                        <td>{{ license.created_at }}</td>
                    </tr>
                    </tbody>
                    <tfoot>
                    <tr>
                        <th></th>
                        <th>{{ t_product_key }}</th>
                        <th>{{ t_customer_name }}</th>
                        <th>{{ t_project_name }}</th>
                        <th>{{ t_clients }}</th>
                        <th>{{ t_type }}</th>
                        <th>{{ t_validity }}</th>
                        <th>{{ t_updated_at }}</th>
                        <th>{{ t_created_at }}</th>
                    </tr>
                    </tfoot>
                </table>
            </div>
        </div>
    </div>
</template>

<script>
    import utility from '../../../utility';
    import {localizeDate} from "../../../../utils/date";

    export default {
        data: function () {
            return {
                t_title: Lang.langChoice("License|Licenses", 2),
                t_new_license: Lang.langGet("Add new license"),
                t_new_project_from_license: Lang.langGet("Create project from license"),
                t_delete_licenses: Lang.langGet("Remove selected licenses"),
                t_product_key: Lang.langGet("Product Key"),
                t_customer_name: Lang.langGet("Customer"),
                t_project_name: Lang.langGet("Project"),
                t_clients: Lang.langChoice("Client|Clients", 2),
                t_type: Lang.langChoice('Type|Types', 1),
                t_validity: Lang.langGet("Validity"),
                t_updated_at: Lang.langGet("Updated at"),
                t_created_at: Lang.langGet("Created at"),

                inner_licenses: [],
            }
        },
        props: [
            'alterPrivilege',
            'licenses',
        ],
        computed: {
            select_count: function () {
                let count = 0;
                _.each(this.inner_licenses, function(license) {
                    if (license.selected) {
                        count++;
                    }
                });
                return count;
            }
        },
        methods: {
            showAddModal: function () {
                EaseEventBus.fire('modifyMode', {'mode': 'add'});
                EaseEventBus.fire('showModal', 'edit-license');
            },
            showAddNewProjectModal: function () {
                EaseEventBus.fire('modifyMode', {'mode': 'add-new-project'});
                EaseEventBus.fire('showModal', 'edit-license');
            },
            showDeleteModal: function () {
                let licenses = [];
                _.each(this.inner_licenses, function (license) {
                    if(license.selected) {
                        licenses.push({'id': license.id, 'productkey': license.productkey});
                    }
                });

                EaseEventBus.fire('modifyMode', {'mode': 'delete', 'licenses': licenses});
                EaseEventBus.fire('showModal', 'edit-license');
            },
        },
        mounted() {
            this.inner_licenses = Object.values(JSON.parse(this.licenses));

            _.each(this.inner_licenses, function(license) {
                if (license.status === 'valid') {
                    license.validity = utility.checkValidity(license.valid_from, license.valid_to);
                } else {
                    license.validity = {'text': license.status};
                }
            });
        }
    }
</script>
